import React from "react";
import { Modal, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import styled from "styled-components";

const EventsModal = (props) => {
  const {
    children,
    hideBackdrop = false,
    open,
    onClose,
    disableClose = false,
  } = props;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={handleClose} hideBackdrop={hideBackdrop}>
      <Wrapper>
        {!disableClose && (
          <CloseLine>
            <CloseWrapper onClick={handleClose}>
              <IconButton>
                <Close />
              </IconButton>
            </CloseWrapper>
          </CloseLine>
        )}
        <ContentWrapper>{children}</ContentWrapper>
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background-color: #fff;
  border: 1px solid #707070;
  border-radius: 10px;
  box-sizing: border-box;
  width: ${({ width }) => (width ? width : "auto")};
  height: ${({ height }) => (height ? height : "auto")};
  padding: 24px 32px 32px 32px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
`;

const CloseLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const CloseWrapper = styled.div`
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 24px;
  }
`;

const ContentWrapper = styled.div`
  padding: 0px 16px 24px 16px;
`;

export default EventsModal;
